module.exports = __webpack_public_path__ + "static/la-ventures--john-ugalino-6d8acb5be568648e7449eb62ca2904a7.mp4";